import * as THREE from 'three';
import Experience from '../Experience';
import vertex from '../Shaders/vertex.glsl';
import fragment from '../Shaders/fragment.glsl';
export default class Curtain {
    constructor(
        position = new THREE.Vector3(-1, 4.9, -7.1),
        size = new THREE.Vector2(2, 3)
    ) {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.debug = this.experience.debug;
        this.position = position;
        this.size = size;
        // Create a curtain mesh
        this.createCurtain();
    }

    createCurtain() {
        this.wavingMaterial = new THREE.RawShaderMaterial({
            uniforms: {
                uTime: { value: 0.0 },
                uFrequency: { value: new THREE.Vector2(1.5, 1.5) }, // Frequency for waving effect
                uColor: { value: new THREE.Color(0x3b3535) }, // Color of the curtain
                uOpacity: { value: 0.8 } // Opacity of the curtain

            },
            vertexShader: vertex,
            fragmentShader: fragment,
            // side: THREE.DoubleSide, // Render both sides of the curtain
            transparent: true,
        });
        const testMesh = new THREE.Mesh(
            new THREE.PlaneGeometry(this.size.x, this.size.y, 64, 64),
            this.wavingMaterial
        );

        testMesh.position.set(this.position.x, this.position.y, this.position.z);
        // Rotate to face the camera and tilt like blowing

        testMesh.rotation.set( 0, -Math.PI / 2, 0);
        


        //add debug folder
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Curtain');
            this.debugFolder.add(this.wavingMaterial.uniforms.uFrequency.value, 'x', 0, 20, 0.1).name('Frequency X');
            this.debugFolder.add(this.wavingMaterial.uniforms.uFrequency.value, 'y', 0, 20, 0.1).name('Frequency Y');
            this.debugFolder.addColor(this.wavingMaterial.uniforms.uColor, 'value').name('Color');
            this.debugFolder.add(this.wavingMaterial.uniforms.uOpacity, 'value', 0, 1, 0.01).name('Opacity');
            //position
            this.debugFolder.add(testMesh.position, 'x', -10, 10, 0.01).name('Position X');
            this.debugFolder.add(testMesh.position, 'y', -10, 10, 0.01).name('Position Y');
            this.debugFolder.add(testMesh.position, 'z', -10, 10, 0.01).name('Position Z');
            //rotation
            this.debugFolder.add(testMesh.rotation, 'x', -Math.PI, Math.PI, 0.01).name('Rotation X');
            this.debugFolder.add(testMesh.rotation, 'y', -Math.PI, Math.PI, 0.01).name('Rotation Y');
            this.debugFolder.add(testMesh.rotation, 'z', -Math.PI, Math.PI, 0.01).name('Rotation Z');
        }

        this.scene.add(testMesh);
    }

    update() {
        // Update logic for the curtain can be added here
        // For example, updating the waving effect based on time
        const time = this.experience.time.elapsed * 0.003; // Convert to seconds
        this.scene.traverse((child) => {
            if (child.material && child.material.uniforms && child.material.uniforms.uTime) {
                child.material.uniforms.uTime.value = time;
                
            }
        });
    }
}